// PDF.js "legacy" derlemesi eski iPad/Safari sürümlerinde de çalışır.
import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';
import type { PDFDocumentLoadingTask, PDFDocumentProxy, RenderTask } from 'pdfjs-dist/legacy/build/pdf.mjs';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs/legacy/build/pdf.worker.min.mjs';

export type { PDFDocumentProxy, RenderTask };

export function openPdf(url: string, onProgress?: (ratio: number) => void): PDFDocumentLoadingTask {
  const task = pdfjs.getDocument({
    url,
    cMapUrl: '/pdfjs/cmaps/',
    cMapPacked: true,
    standardFontDataUrl: '/pdfjs/standard_fonts/',
    wasmUrl: '/pdfjs/wasm/',
    iccUrl: '/pdfjs/iccs/',
  });
  if (onProgress) {
    task.onProgress = ({ loaded, total }: { loaded: number; total: number }) => {
      if (total) onProgress(Math.min(1, loaded / total));
    };
  }
  return task;
}
